export const FORM_META_SET_SCHEMA = 'FORM_META_SET_SCHEMA'
export const FORM_META_CLEAR_SCHEMA = 'FORM_META_CLEAR_SCHEMA'
